module.exports = __webpack_public_path__ + "static/media/balance-block.20296414.webp";